module.exports = __webpack_public_path__ + "assets/b6f321c55d544da4dca13c41328ab698.mp3";